export class ScreenPresentationConfig {
    constructor(presentationStyle, animated) {
        this.presentationStyle = presentationStyle;
        this.animated = animated === undefined ? true : animated;
    }
}
//# sourceMappingURL=ScreenPresentationConfig.js.map